import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 身分證件上傳 PostBack
 */
const IdDocUploadPostBack = (postbackData: any): Promise<GeneralResp> => {
    const url = RouteUrlList.API_IdDocUploadPostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, postbackData, config).then((res: AxiosResponse<GeneralResp>) => {
        return res.data;
    });
};

export default IdDocUploadPostBack;
